import { FC } from "react";
import SvgIconConstituentValues from "./iconTypes";

export interface SvgIcon extends FC<SvgIconConstituentValues> {}

const Maennlich: SvgIcon = ({ fillColor, altText }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="120px"
    height="120px"
    viewBox="0 0 534.476 544.001"
    enableBackground="new 0 0 534.476 544.001"
    xmlSpace="preserve"
  >
    <g>
      <defs>
        <rect id="SVGID_1_" width="534.476" height="544.001" />
      </defs>
      <clipPath id="SVGID_2_">
        <use xlinkHref="#SVGID_1_" overflow="visible" />
      </clipPath>
      <path
        clipPath="url(#SVGID_2_)"
        fill={fillColor}
        d="M534.476,544.001C534.476,256.812,414.829,24,267.238,24
		C119.647,24,0,256.812,0,544.001H534.476z"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M264.914,277.613c4.473-5.109,4.579-17.88,4.579-17.88s-8.297,8.582-22.219,13.609
		c-0.738,0.267-1.32,0.513-1.816,0.747c-7.699,3.141-14.633,7.98-19.918,14.589c-28.172-9.836-27.809-47.732-49.168-64.271
		c6.902,68.305,31.309,112.27,92.008,127.18c57.008-13.273,96.926-69.566,88.633-125.72c-13.262,18.012-18.715,52.012-46.316,63.504
		c-4.629-5.985-10.616-10.543-17.293-13.789c-0.472-0.461-1.519-1.024-3.351-1.719c-13.841-5.25-19.754-14.297-19.754-14.297
		s-0.957,11.555,3.699,18.125c11.784,1.184,20.689,6.48,20.641,12.776c-0.059,7.081-11.435,12.738-25.418,12.621
		c-13.981-0.109-25.267-5.95-25.211-13.032c0.054-6.304,9.07-11.461,20.906-12.439L264.914,277.613z"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M162.604,130.433c-1.234,25.281,2.902,51.517,14.043,73.527
		c9.316-23.547,12.516-53.312,25.75-72.883c23.301,0.293,47.699,0.434,69.187,0.211c18.346,0.524,39.927,0.77,61.146,0.86
		c10.02,20.89,7.973,53.647,26.396,66.272c8.086-22.94,13.239-45.367,14.36-66.269c31.254-0.11,54.926-0.426,54.926-0.426
		c5.836-38.617-49.574-16.051-48.543-29.849c1.035-13.8-9.426-86.604-27.77-95.038c-14.018-6.446-46.966-6.59-79.764-6.446
		c-38.823-0.722-71.808-1.113-85.937,5.11c-18.473,8.137-30.105,80.766-29.301,94.577c0.809,13.817-54.227-9.64-49.017,29.063
		c0-0.008,23.075,0.676,54.521,1.289L162.604,130.433z"
      />
      <path
        clipPath="url(#SVGID_2_)"
        d="M453.234,408.993l-0.521-0.512c-15.218-10.992-38.671-19.56-61.362-27.837
		c-8.27-3.019-16.406-6-24.102-9.05c-2.235-0.883-23.625-8.629-25.771-9.527c-14.832,11.629-54.742,61.533-74.242,61.533
		c-19.504,0-59.409-49.9-74.245-61.533c-2.145,0.898-23.535,8.645-25.771,9.527c-7.695,3.05-15.832,6.03-24.097,9.05
		c-22.689,8.277-46.149,16.845-61.364,27.837l-0.519,0.512C44.1,444.176,52.913,543.972,52.913,543.972l428.65,0.004
		c0,0,8.812-99.8-28.328-134.989L453.234,408.993z"
      />
    </g>
    <title>{altText}</title>
  </svg>
);

export default Maennlich;
